import { collection, doc, getDocs, addDoc, updateDoc, deleteDoc, serverTimestamp, query, orderBy } from 'firebase/firestore';
import { db } from './firebase';
import type { Newcomer, NewcomerFormData } from '../types/newcomer';

const newcomersCollectionRef = collection(db, 'newcomers');

export const newcomerService = {
  /**
   * 모든 새가족 목록을 가져옵니다.
   */
  async getAllNewcomers(): Promise<Newcomer[]> {
    const q = query(newcomersCollectionRef, orderBy('createdAt', 'desc'));
    const data = await getDocs(q);
    return data.docs.map(doc => ({ ...doc.data(), id: doc.id })) as Newcomer[];
  },

  /**
   * 새로운 새가족 정보를 추가합니다. (관리번호 생성 로직 제거)
   * @param newcomerData 폼에서 받은 새가족 정보
   */
  async addNewcomer(newcomerData: NewcomerFormData): Promise<string> {
    // 이제 customId를 만드는 복잡한 로직이 모두 사라졌습니다.
    // Cloud Function이 이 데이터를 감지하고 알아서 customId를 추가해줄 것입니다.
    const docRef = await addDoc(newcomersCollectionRef, { 
      ...newcomerData,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp() 
    });
    return docRef.id;
  },

  /**
   * 특정 새가족의 정보를 업데이트합니다.
   * @param id 수정할 새가족의 문서 ID
   * @param updates 수정할 정보
   */
  async updateNewcomer(id: string, updates: Partial<NewcomerFormData>): Promise<void> {
    const newcomerDoc = doc(db, 'newcomers', id);
    await updateDoc(newcomerDoc, {
      ...updates,
      updatedAt: serverTimestamp(),
    });
  },

  /**
   * 특정 새가족의 정보를 삭제합니다.
   * @param id 삭제할 새가족의 문서 ID
   */
  async deleteNewcomer(id: string): Promise<void> {
    const newcomerDoc = doc(db, 'newcomers', id);
    await deleteDoc(newcomerDoc);
  },
};